export const CheckboxSVG = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" {...props}>
        <g id="Checkbox" transform="translate(-203 -5545)">
            <g id="Rectangle_656" data-name="Rectangle 656" transform="translate(203 5545)" fill="#fff" stroke="#ced4da" strokeWidth="1">
                <rect width="31" height="31" stroke="none" />
                <rect x="0.5" y="0.5" width="30" height="30" fill="none" />
            </g>
        </g>
    </svg>
);
